export enum Overflow {
  visible,
  clip,
}
